import { Navigate, Route, Routes } from 'react-router-dom';

import { CAMINHO_INICIAL, mapaDeNavegacao } from './shared/navegacao/mapaDeNavegacao';
import { DetalheDaTriagem } from './features/fila-de-triagem/DetalheDaTriagem';
import { DetalheDoCaso } from './features/casos/DetalheDoCaso';
import { FalhasDeEmail } from './features/falhas-de-email/FalhasDeEmail';
import { FilaDaAvaliadora } from './features/fila-da-avaliadora/FilaDaAvaliadora';
import { useIdentidade } from './features/autenticacao/ContextoDeIdentidade';
import { FilaDeTriagem } from './features/fila-de-triagem/FilaDeTriagem';
import { ListaDeCasos } from './features/casos/ListaDeCasos';
import { PaginaDeCaptacao } from './features/casos/captacao/PaginaDeCaptacao';
import { PaginaDeCondutaMedica } from './features/conduta-medica/PaginaDeCondutaMedica';
import { PaginaDeConhecimento } from './features/conhecimento/PaginaDeConhecimento';
import { PaginaDeContratos } from './features/contratos/PaginaDeContratos';
import { PaginaDeRevisao } from './features/contratos/revisao/PaginaDeRevisao';
import { DetalheDaConferencia } from './features/faturamento/DetalheDaConferencia';
import { PaginaDeFaturamento } from './features/faturamento/PaginaDeFaturamento';
import { PaginaDeGlosas } from './features/glosas/PaginaDeGlosas';
import { PaginaDaCiDiaria } from './features/ci-diaria/PaginaDaCiDiaria';
import { PaginaDeParametrizacao } from './features/parametrizacao/PaginaDeParametrizacao';
import { PaginaDePrestadores } from './features/prestadores/PaginaDePrestadores';
import { PaginaDaVisaoGeral } from './features/visao-geral/PaginaDaVisaoGeral';
import { PaginaDoDashboard } from './features/dashboard/PaginaDoDashboard';
import { PaginaDeLogin } from './features/autenticacao/PaginaDeLogin';
import { PaginaDoTema } from './tema/PaginaDoTema';
import { PaginaEmConstrucao } from './features/em-construcao/PaginaEmConstrucao';
import { RotaProtegida } from './features/autenticacao/RotaProtegida';
import { TrilhaDeAcesso } from './features/trilha-de-acesso/TrilhaDeAcesso';
import { Shell } from './shared/layout/Shell';

/** A fila da avaliadora abre nos vencidos para a coordenação (`TP-065`, `D6`): o papel sai da sessão aqui, na rota. */
function FilaDaAvaliadoraDaSessao(): React.JSX.Element {
  const { sessao } = useIdentidade();
  return <FilaDaAvaliadora papel={sessao?.papel} />;
}

/**
 * TODA entrada do mapa vira rota. As que ainda não têm tela caem em
 * `PaginaEmConstrucao` — rota real, estado explícito, nunca 404.
 *
 * O `*` no fim continua existindo para endereço digitado errado; a
 * diferença é que ele não pega mais nenhuma tela do produto.
 */
export function Rotas(): React.JSX.Element {
  return (
    <Routes>
      <Route path="/entrar" element={<PaginaDeLogin />} />

      <Route element={<RotaProtegida />}>
        <Route element={<Shell />}>
          <Route index element={<Navigate to={CAMINHO_INICIAL} replace />} />

          <Route path="/visao-geral" element={<PaginaDaVisaoGeral />} />
          <Route path="/casos" element={<ListaDeCasos />} />
          <Route path="/casos/:id" element={<DetalheDoCaso />} />
          <Route path="/captacao-siai" element={<PaginaDeCaptacao />} />
          {/* O quadro mora na tela da captacao. O endereco antigo continua
              valendo: a historia S1-11 do cliente tem nome proprio e o link
              circulou, entao ele redireciona em vez de dar 404. */}
          <Route path="/painel-da-captacao" element={<Navigate to="/captacao-siai" replace />} />
          <Route path="/fila-da-avaliacao" element={<FilaDaAvaliadoraDaSessao />} />
          <Route path="/fila-de-triagem" element={<FilaDeTriagem />} />
          <Route path="/fila-de-triagem/:ticketId" element={<DetalheDaTriagem />} />
          <Route path="/trilha-de-acesso" element={<TrilhaDeAcesso />} />
          <Route path="/falhas-de-email" element={<FalhasDeEmail />} />
          <Route path="/contratos" element={<PaginaDeContratos />} />
          <Route path="/contratos/fontes/:fonteId/revisao" element={<PaginaDeRevisao />} />
          <Route path="/contratos/:contratoId/parametrizacao" element={<PaginaDeParametrizacao />} />
          <Route path="/faturamento" element={<PaginaDeFaturamento />} />
          <Route path="/faturamento/:conferenciaId" element={<DetalheDaConferencia />} />
          <Route path="/ci-diaria" element={<PaginaDaCiDiaria />} />

          {/* Portadas do protótipo, ainda sobre fixture — ADR-0005. A
              fronteira da fonte fica no topo de cada arquivo. */}
          <Route path="/conduta-medica" element={<PaginaDeCondutaMedica />} />
          <Route path="/glosa-e-recurso" element={<PaginaDeGlosas />} />
          <Route path="/fechamento-de-prestadores" element={<PaginaDePrestadores />} />
          <Route path="/base-de-conhecimento" element={<PaginaDeConhecimento />} />
          <Route path="/dashboard-executivo" element={<PaginaDoDashboard />} />

          {mapaDeNavegacao
            .filter((entrada) => !entrada.construida)
            .map((entrada) => (
              <Route
                key={entrada.chave}
                path={entrada.caminho}
                element={<PaginaEmConstrucao chave={entrada.chave} />}
              />
            ))}

          {/* Só em dev: a documentação viva do tema não vai para produção. */}
          {import.meta.env.DEV ? <Route path="/_tema" element={<PaginaDoTema />} /> : null}

          <Route path="*" element={<PaginaEmConstrucao chave="__desconhecida__" />} />
        </Route>
      </Route>
    </Routes>
  );
}
